
import { Environment } from 'src/app/models';

export const environment = new Environment({
  type: 'PROD',
  api: { protocol: 'https:', hostname: 'auth.huronaccelerators.com', port: 443, pathname: '/v1.0', search: 'appId=-1' },
});
